/**
 * @license Angular v20.3.13
 * (c) 2010-2025 Google LLC. https://angular.dev/
 * License: MIT
 */

function setAlternateWeakRefImpl(impl) {
    // TODO: remove this function
}

export { setAlternateWeakRefImpl };
//# sourceMappingURL=weak_ref.mjs.map
